import { render, staticRenderFns } from "./KeywordSearchPage.vue?vue&type=template&id=e2e74a7a&scoped=true"
import script from "./KeywordSearchPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeywordSearchPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./KeywordSearchPage.vue?vue&type=style&index=0&id=e2e74a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e74a7a",
  null
  
)

export default component.exports